import React from "react";
import ECLBlock from "../ECLBlock";
import "./Columns.css";

export default function Columns(props) {
   return (
      <div className="blockument-column-container">
         {props.block.children.map((c, i) => {
            return (
               <div
                  key={c}
                  className="blockument-column"
                  style={{
                     width: `calc(100% * ${props.block.data?.columnWidths ? props.block.data.columnWidths?.[i] : 1 / props.block.children.length})`,
                  }}
               >
                  {props.flatDoc[c].children.map((child) => {
                     return (
                        <ECLBlock
                           key={child}
                           block={props.flatDoc[child]}
                           project={props.project}
                           flatDoc={props.flatDoc}
                           setFlatDoc={props.setFlatDoc}
                           flatKey={child}
                           headlist={props.headlist}
                           parentDoc={props.parentDoc}
                           revisionCount={props.revisionCount}
                           incrementRevision={props.incrementRevision}
                           navigateTo={props.navigateTo}
                           setNavigateTo={props.setNavigateTo}
                        />
                     );
                  })}
               </div>
            );
         })}
      </div>
   );
}
